var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCreateChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.163,
    height: 20.987,
    viewBox: "0 0 21.163 20.987",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1250",
    "data-name": "Group 1250",
    transform: "translate(-560.154 -166.616)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-open-in-new",
    "data-name": "Icon material-open-in-new",
    d: "M19.474,19.474H6.372V6.372h8.635V4.5H6.372A1.871,1.871,0,0,0,4.5,6.372v13.1a1.871,1.871,0,0,0,1.872,1.872h13.1a1.877,1.877,0,0,0,1.872-1.872V11.381H19.474Z",
    transform: "translate(555.654 166.257)",
    fill: "#121b25"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1053",
    "data-name": "Group 1053"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_feather-edit-2",
    "data-name": "Icon feather-edit-2",
    d: "M13.126,3.817c.746-.746,1.684-.375,2.43.371s1.016,1.584.27,2.329L6.713,15.63,3,16.643,4.013,12.93Z",
    transform: "translate(564.243 163.96)",
    fill: "none",
    stroke: "#121b25",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_133",
    "data-name": "Line 133",
    x2: 2,
    y2: 2,
    transform: "translate(576.5 169.5)",
    fill: "none",
    stroke: "#121b25",
    strokeWidth: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCreateChat);
export default __webpack_public_path__ + "static/media/icon-create-chat.f0fd886afc2999813494235db9c9c0b4.svg";
export { ForwardRef as ReactComponent };